// extracted by mini-css-extract-plugin
export var box = "_58-0";
export var check = "_58-1";
export var checkboxButton = "_58-6";
export var checkboxGroup = "_58-5";
export var disabled = "_58-7";
export var ghost = "_58-9";
export var input = "_58-2";
export var label = "_58-4";
export var normal = "_58-8";
export var uncheck = "_58-3";